// @flow

import * as React from 'react';
import { Box } from 'grommet';
import styled from 'styled-components';
import useResizeObserver from '@react-hook/resize-observer';
import { CONTEXT_NAVBAR_HEIGHT, HEADER_HEIGHT } from 'esm-web-pro/styles/theme';


type Props = {
    children: React.Node,
    ...React.ElementConfig<Box>,
}

const StyledContextNavbar = styled(Box)`
    height: ${CONTEXT_NAVBAR_HEIGHT};
    background-color: #ecedef;
    position: fixed;
    top: ${HEADER_HEIGHT};
    z-index: 1;
    box-shadow: 0 10px 10px -5px #d5d6d9;
`;


const ContextNavbar = (props: Props) => {
    const { children, ...rest } = props;

    const boxRef = React.useRef(null);

    const [parentNode, setParentNode] = React.useState(null);
    const [parentSize, setParentSize] = React.useState(null);

    React.useLayoutEffect(() => {
        if (parentNode) {
            setParentSize(parentNode.getBoundingClientRect());
        }
    }, [parentNode]);

    React.useEffect(() => {
        setParentNode(boxRef.current?.parentNode);
    }, []);

    useResizeObserver(parentNode, (entry) => setParentSize(entry.contentRect));

    return (
        <StyledContextNavbar
            ref={boxRef}
            pad={{ horizontal: 'medium' }}
            direction="row"
            justify="between"
            width={parentSize ? `${parentSize.width}px` : `calc(100vw - ${CONTEXT_NAVBAR_HEIGHT})`}
            {...rest}
        >
            { children }
        </StyledContextNavbar>
    );
};

ContextNavbar.defaultProps = {

};

export default ContextNavbar;
